export default __webpack_public_path__ + "static/media/InternsPlanet.04dce8db8cf28ec12e2cf93d43a0e1ac.webp";